import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UtilService } from './util-service';

@Injectable()
export class AmbienteService {

  constructor(private utilService: UtilService) {
  }

  public getVersaoApi() {
    let urlObtencaoDados: string = "ambiente/versao";
    return this.utilService.getJSON(urlObtencaoDados);
  }

}



// WEBPACK FOOTER //
// ./src/providers/ambiente-service.ts